/**
 *   =================== INS ERROR ===========================
 */
export const INS_RESPONSE_ERROR_MSG = {
  LOGIN_REQUIRED: "login_required",
  CHALLENGE_REQUIRED: "challenge_required",
  FEEDBACK_REQUIRED: "feedback_required",
  CHECKPOINT_REQUIRED: "checkpoint_required",
  CHECKPOINT_LOGGED_OUT: "checkpoint_logged_out",
  CHECKPOINT_CHALLENGE_REQUIRED: "checkpoint_challenge_required",
  INS_ERROR_OTHER: "others",
  RATE_LIMIT: "rate_limit_error"
};

/**
 *    =================== INS CHANLLENG REQUIRE ===========================
 */
export const INS_CHALLENG_STEP_NAME = {
  SELECT_VERIFY_METHOD: "select_verify_method", // 选择验证方式
  VERIFY_PHONE_NUMBER: "verify_phone_number", // 手机验证
  VERIFY_CODE: "verify_code", // 手机验证
  VERIFY_EMAIL: "verify_email", // 邮箱验证
  DELTA_LOGIN_REVIEW: "delta_login_review", // review 是我本人 | 不是我本人
  SUBMIT_PHONE: "submit_phone"
};

export const INS_CHALLENG_CHOICE = {
  PHONE: "phone_number",
  EMAIL: "email"
};
/**
 * =====================  login 相关的信息 ============================
 */
export const INS_LOGIN_MSG = {
  INS_LOGIN_SUCCESS: "ins_login_success", // 请求成功
  INS_LOGIN_NEED_CREATE_ACCOUNT: "ins_login_need_create_account", // fb登陆 没有创建ins的用户
  INS_LOGIN_FAILURE: "ins_login_failure", // 请求错误
  INS_LOGIN_OTHER_FAILURE: "ins_login_other_failure", // 密码或者其他错误
  INS_LOGIN_TWO_FACTOR: "ins_login_two_factor", // 需要两步验证
  INS_LOGIN_UNCAUGHT_ERROR: "ins_login_uncaught_error",
  UNCAUGHT_ERROR_MSG: { message: "Oops, an error occurred." },
  INS_LOGIN_CHALLENGE: "ins_login_challenge", // 需要INS远程验证
  INS_LOGIN_CHALLENGE_VERIFY: "ins_login_challenge_verify", // chanllenge 的verify
  INS_LOGIN_FAILURE_CLOSE: "ins_login_failure_close",
  INS_LOGIN_FAILURE_DELTA: "ins_login_failure_delta" // 请求 delta_login_review
};

// ======================== native error ========================
export const REQUEST_NET_ERROR = "request_internet_error";
export const REQUEST_UNCAUGHT_ERROR = "request_uncaught_error";

export const statusRes = (status: string, data: any) => ({ status, data });

export const INS_LOGIN_NEED_CREATE_ACCOUNT_ERROR = statusRes(
  INS_LOGIN_MSG.INS_LOGIN_NEED_CREATE_ACCOUNT,
  { message: "Please create your instagram account before login." }
);

export const isRequestError = (error: any) => {
  return error.code && error.message;
};

export const INS_UNCAUGHT_ERROR = statusRes(
  INS_LOGIN_MSG.INS_LOGIN_UNCAUGHT_ERROR,
  INS_LOGIN_MSG.UNCAUGHT_ERROR_MSG
);

export const requestNetErrorResolve = (error: any) => {
  return statusRes(REQUEST_NET_ERROR, error);
};

export const insLoginErrorResolve = (error: any) => {
  return isRequestError(error)
    ? requestNetErrorResolve(error)
    : error.status && error.status === "fail"
    ? statusRes(INS_LOGIN_MSG.INS_LOGIN_OTHER_FAILURE, error)
    : statusRes(INS_LOGIN_MSG.INS_LOGIN_FAILURE, error);
};
